import { render, staticRenderFns } from "./Own.vue?vue&type=template&id=ff5543a4&scoped=true"
import script from "./Own.vue?vue&type=script&lang=js"
export * from "./Own.vue?vue&type=script&lang=js"
import style0 from "./Own.vue?vue&type=style&index=0&id=ff5543a4&prod&lang=css"
import style1 from "./Own.vue?vue&type=style&index=1&id=ff5543a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5543a4",
  null
  
)

export default component.exports